import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  VStack,
  Text,
  useColorModeValue,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';
import {
  FiBook,
  FiActivity,
  FiFileText,
  FiPieChart,
} from 'react-icons/fi';
import ChatbotKnowledgeBase from './chatbot-agent/KnowledgeBase';
import ChatbotTranscription from './chatbot-agent/Transcript';
import ChatbotAnalytics from './chatbot-agent/Analytics';

const ChatbotAgent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState(0);

  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  const menuItems = [
    { path: 'analytics', label: 'Analytics', icon: FiPieChart },
    { path: 'knowledge-base', label: 'Knowledge Base', icon: FiBook },
    { path: 'transcript', label: 'Transcript', icon: FiFileText },
  ];

  const routeToTabIndex = {
    '/admin/chatbot-agent/analytics': 0,
    '/admin/chatbot-agent/knowledge-base': 1,
    '/admin/chatbot-agent/transcript': 2,
  };

  const tabIndexToRoute = {
    0: '/admin/chatbot-agent/analytics',
    1: '/admin/chatbot-agent/knowledge-base',
    2: '/admin/chatbot-agent/transcript',
  };

  useEffect(() => {
    const path = location.pathname;
    const index = routeToTabIndex[path];
    if (index !== undefined) {
      setTabIndex(index);
    } else {
      if (location.pathname === '/admin/chatbot-agent' || location.pathname === '/admin/chatbot-agent/') {
        navigate(tabIndexToRoute[0], { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  const handleTabsChange = (index) => {
    setTabIndex(index);
    const route = tabIndexToRoute[index];
    if (route) {
      navigate(route);
    }
  };

  return (
    <Box minH="100vh" bg={bgColor} p={6}>
      <VStack spacing={6} align="stretch">
        <Heading
          size="lg"
          bgGradient="linear(to-r, purple.500, blue.400)"
          bgClip="text"
        >
          Chatbot Agent
        </Heading>
        <Text color={textColor}>
          Manage your chatbot agents, monitor conversations, and analyze performance.
        </Text>

        <Tabs
          variant="enclosed"
          colorScheme="purple"
          index={tabIndex}
          onChange={handleTabsChange}
        >
          <TabList>
            {menuItems.map((item, index) => (
              <Tab key={item.path} leftIcon={<item.icon />}>
                {item.label}
              </Tab>
            ))}
          </TabList>

          <TabPanels>
            <TabPanel>
              <ChatbotAnalytics />
            </TabPanel>
            <TabPanel>
              <ChatbotKnowledgeBase />
            </TabPanel>
            <TabPanel>
              <ChatbotTranscription />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </VStack>
    </Box>
  );
};

export default ChatbotAgent;
